import * as React from "react";
const SvgFiRrChoose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-choose_svg__a)">
      <path
        fill="#062147"
        d="M3 8h2c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3H3C1.346 0 0 1.346 0 3v2c0 1.654 1.346 3 3 3M2 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm6 12v-2c0-1.654-1.346-3-3-3H3c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3m-2 0a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm7-7h2c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3m-1-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm1 1.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5m10.998 18.441a1 1 0 0 1-.939 1.057l-.06.002a1 1 0 0 1-.997-.941 3 3 0 0 0-1.941-2.634l-4.38-1.478A1 1 0 0 1 15 18v-5.893c0-.538-.362-1.018-.825-1.093A1 1 0 0 0 13 12v8.454c0 .608-.341 1.15-.889 1.415a1.56 1.56 0 0 1-1.66-.187L8.68 20.268a1.001 1.001 0 0 0-1.364 1.464l.568.548c.648.624.206 1.72-.694 1.72a1 1 0 0 1-.694-.28l-.558-.538a2.995 2.995 0 0 1 4.022-4.438l1.039.82v-7.563c0-.882.386-1.715 1.058-2.286a3.01 3.01 0 0 1 2.439-.674c1.427.232 2.503 1.552 2.503 3.067v5.175l3.73 1.259a5.01 5.01 0 0 1 3.268 4.4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-choose_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChoose;
